const USE_ASCII = false;

export const PASS = '✓';
export const FAIL = '✗';
export const PENDING = '⧖';
export const COMPLETION = '\u203A'; //'▸';
export const MEASURE = '◷';
export const ERROR = USE_ASCII ? '[x]' : '❌ ';
export const WARNING = USE_ASCII ? '[!]' : '⚠️ ';
export const INDENT = '    ';
export const BREADCRUMB = '»';
